import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

// Preload all lazy-loaded components
import('./components/LandingPage');
import('./components/CourseCatalog');
import('./components/CourseDetail');
import('./components/CourseOutline');
import('./components/FractionalPMPage');
import('./components/AIWorkshopPage');
import('./components/BlogLayout');
import('./components/BlogList');
import('./components/BlogPost');
import('./components/CategoryList');
import('./components/AuthorList');
import('./components/CategoryIndex');
import('./components/AuthorIndex');
import('./components/AdminLayout');
import('./components/AdminLogin');
import('./components/AdminPosts');
import('./components/AdminAuthors');
import('./components/AdminCategories');
import('./components/AdminTags');
import('./components/AboutPage');
import('./components/AdminCourses');
import('./components/AdminCourseEditor');
import('./components/AdminCourseCategories');
import('./components/AdminCourseTags');
import('./components/AdminAssets');
import('./components/TimelinePage');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

// Only register service worker in production and if supported
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  serviceWorkerRegistration.register();
}